export default function FormatBoldIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 20}
      height={height ? height : width ? width : 20}
      viewBox="0 96 960 960"
    >
      <path
        fill="currentColor"
        d="M333.304 870.131q-33.478 0-56.348-23.152-22.87-23.153-22.87-56.631V361.087q0-33.478 22.87-56.631 22.87-23.152 56.348-23.152h183.262q71.087 0 121 45.674t49.913 111.37q0 33.478-19.021 68.586-19.022 35.109-60.24 53.805v7.131q50.914 16.826 74.588 57.348 23.673 40.522 23.673 80.434 0 63.478-51.369 113.979-51.37 50.5-132.109 50.5H333.304Zm20.913-83.913h154.74q29.521 0 61.76-22.174 32.24-22.174 32.24-66.957 0-43.783-31.957-66.239-31.957-22.457-60.913-22.457h-155.87v177.827Zm0-257.74h147.305q31.608 0 58.804-23t27.196-59.13q0-34.435-26.065-58.783-26.066-24.348-60.5-24.348h-146.74v165.261Z"
      />
    </svg>
  );
}
